export default __webpack_public_path__ + "static/media/chantier.ca0f5674.svg";